<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <doviz ref="doviz" @setCurrencyValue="setCurrency($event)"></doviz>
    <v-form ref="formTicket" v-model="valid">
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{ $t("Passenger-Details") }} </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-flex>
        </v-layout>
        <v-layout row wrap pa-2>
          <!-- BILGILER -->

          <!-- Yolcu Bilgileri -->
          <v-flex xs12 sm8 md8 pr-2 v-if="ticketAllocate.length > 0">
            <v-card class="pa-2 mb-2">
              <v-layout class="project overdue" row wrap>
                <v-flex xs12 pb-2 sm12 md12>
                  <v-layout row wrap>
                    <v-toolbar flat="" size="120px" dark color="white">
                      <v-toolbar-title>
                        <span class="header black--text">
                          {{ $t("Passenger-Details") }}
                        </span>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-layout>
                </v-flex>
              </v-layout>
              <!-- Yolcularin Bilgileri -->

              <v-layout
                row
                wrap
                v-for="(paxs, ind) in paxList"
                v-bind:key="ind"
              >
                <v-flex xs12 sm10 md10 class="title my-auto">
                  {{ ind + 1 }} . {{ paxs.PaxType | passengerType }}
                  {{ $t("Passenger") }}
                </v-flex>
                <v-flex>
                  <v-checkbox
                    @change="defaultContact(paxs, ind)"
                    :disabled="isUpdate"
                    v-model="contactValueList[ind]"
                    :label="$t('Default-Contact')"
                  ></v-checkbox>
                </v-flex>

                <v-flex xs12 sm3 md3>
                  <v-select
                    :label="$t('Sex-v2')"
                    :items="genderItems"
                    item-text="text"
                    item-value="value"
                    v-model="paxs.Gender"
                    :rules="[rules.required]"
                    :disabled="isUpdate"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    :label="$t('Name_label')"
                    v-model="paxs.FirstName"
                    @change="changeFirstName(paxs.FirstName)"
                    :disabled="isUpdate"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    :label="$t('Surname_label')"
                    v-model="paxs.LastName"
                    @change="changeLastName(paxs.LastName)"
                    :disabled="isUpdate"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    :label="$t('Email_label')"
                    v-model="paxs.Email"
                    @change="changeEmail(paxs.Email)"
                    :disabled="isUpdate"
                    :rules="[rules.required, rules.email]"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm3 md3>
                  <v-autocomplete
                    :label="$t('Nationality')"
                    :items="countryItems"
                    item-text="name"
                    item-value="code"
                    v-model="paxs.Nationality"
                    :rules="[rules.required]"
                    :disabled="isUpdate"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <tarihim
                    :etiket="'Dogum Tarihi'"
                    :aktifmi="isUpdate"
                    v-model="paxs.BirthDate"
                    :detaygizle="false"
                    :rules="[(v) => !!v || $t('Please-select-a-date')]"
                  ></tarihim>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    :label="$t('Telephone')"
                    :disabled="isUpdate"
                    v-model="paxs.Phone"
                    @change="changePhone(paxs.Phone)"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    :label="$t('T-C-Identity-Number')"
                    :disabled="isUpdate"
                    v-model="paxs.CitizenNo"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm3 md3>
                  <v-autocomplete
                    :label="$t('Wheelchair')"
                    :items="WheelChairItems"
                    item-text="text"
                    item-value="value"
                    v-model="paxs.WheelChairService"
                    :disabled="isUpdate"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <tarihim
                    :etiket="$t('Passport-Expiry-Date-v2')"
                    :aktifmi="isUpdate"
                    v-model="paxs.PassportExpireDate"
                    :detaygizle="false"
                    :rules="[(v) => !!v || $t('Please-select-a-date')]"
                  ></tarihim>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    :label="$t('Passport-Number')"
                    hint="Yurtdisi ucuslar ve yabanci yolcular icin girilmelidir"
                    v-model="paxs.PassportNo"
                    :rules="[rules.required]"
                    :disabled="isUpdate"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm4 md6 xl3>
                  <v-text-field
                    :label="$t('Mile-Card')"
                    hint="Miles & Miles"
                    v-model="paxs.FrequentFlayerNo"
                    :disabled="isUpdate"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md6 xl3>
                  <v-text-field
                    :label="$t('HES-Code')"
                    v-model="paxs.HesCode"
                    :disabled="isUpdate"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card>

            <!-- Iletisim Bilgileri -->

            <v-card class="pa-2 mb-2">
              <v-layout class="project overdue" row wrap>
                <v-flex xs12 pb-2 sm12 md12>
                  <v-layout row wrap>
                    <v-toolbar flat="" size="120px" dark color="white">
                      <v-toolbar-title>
                        <span class="header black--text">
                          Iletisim Bilgileri
                        </span>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    :label="$t('Name_label')"
                    :disabled="isUpdate"
                    v-model="updatePassengerItem.Contact.Name"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    :label="$t('Surname_label')"
                    :disabled="isUpdate"
                    v-model="updatePassengerItem.Contact.LastName"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    :label="$t('Telephone')"
                    :disabled="isUpdate"
                    v-model="updatePassengerItem.Contact.Phone"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    :label="$t('Email_label')"
                    :disabled="isUpdate"
                    v-model="updatePassengerItem.Contact.Email"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card>
            <!-- Fatura Bilgileri -->

            <v-card class="pa-2 mb-2">
              <v-layout class="project overdue" row wrap>
                <v-flex xs12 pb-2 sm12 md6>
                  <v-layout row wrap>
                    <v-toolbar flat="" size="120px" dark color="white">
                      <v-toolbar-title>
                        <span class="header black--text">
                          {{ $t("Invoice-Details") }}
                        </span>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12 pl-2>
                  <caricomp
                    v-model="cariItem"
                    v-bind:zorunlumu="true"
                    :aktifmi="isUpdate"
                  ></caricomp>
                </v-flex>
              </v-layout>
            </v-card>

            <!-- Not Bilgileri -->

            <v-card class="pa-2">
              <v-layout class="project overdue" row wrap>
                <v-flex xs12 pb-2 sm12 md6>
                  <v-layout row wrap>
                    <v-toolbar flat="" size="120px" dark color="white">
                      <v-toolbar-title>
                        <span class="header black--text">
                          {{ $t("Note") }}
                        </span>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12 pr-2 pt-2>
                  <v-textarea
                    :label="$t('Reservation-Note')"
                    :hint="
                      $t('Not-sent-entered-airline-showed-for-corporation')
                    "
                    v-model="updatePassengerItem.Notes"
                    outline
                    :disabled="isUpdate"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

          <!-- BILET DETAYLARI -->
          <v-flex xs12 sm4 md4 v-for="(item, i) in ticketAllocate" :key="i">
            <v-card class="pa-2">
              <v-layout class="project overdue" row wrap>
                <v-flex xs12 pb-2 sm12 md12>
                  <v-layout row wrap>
                    <v-toolbar flat="" size="120px" dark color="white">
                      <v-toolbar-title>
                        <span class="header black--text">
                          {{ $t("Flight-Details-v2") }}
                        </span>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-layout>
                </v-flex>
              </v-layout>
              <!-- AKTARMASIZ GIDIS DONUS -->
              <!-- AKTARMALI TEK YON -->
              <v-card
                class="my-2 elevation-4"
                v-if="item.FlightSegments.length == 2"
              >
                <v-layout row wrap>
                  <v-flex xs12 sm4 md2 class="my-auto">
                    <v-img
                      :src="getImgUrl(item.FlightSegments[0].OperatingAirline)"
                      alt="K"
                      height="35px"
                      width="85px"
                      contain
                    >
                    </v-img>
                  </v-flex>
                  <v-flex xs12 sm4 md5>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title
                          >{{
                            item.FlightSegments[0].DepartureDate.substring(
                              0,
                              10
                            )
                          }}
                          {{
                            item.FlightSegments[0].DepartureTime
                          }}</v-list-tile-title
                        >
                        <v-list-tile-sub-title
                          >{{ item.FlightSegments[0].DepartureAirportName }} ({{
                            item.FlightSegments[0].DepartureAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>

                  <v-flex xs12 sm4 md5>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title
                          >{{
                            item.FlightSegments[0].ArrivalDate.substring(0, 10)
                          }}
                          {{
                            item.FlightSegments[0].ArrivalTime
                          }}</v-list-tile-title
                        >
                        <v-list-tile-sub-title>
                          {{ item.FlightSegments[0].ArrivalAirportName }} ({{
                            item.FlightSegments[0].ArrivalAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-layout row wrap>
                  <v-flex xs12 sm4 md2 class="my-auto">
                    <v-img
                      :src="getImgUrl(item.FlightSegments[1].OperatingAirline)"
                      alt="K"
                      height="35px"
                      width="85px"
                      contain
                    >
                    </v-img>
                  </v-flex>
                  <v-flex xs12 sm4 md5>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title>{{
                          item.FlightSegments[1].DepartureTime
                        }}</v-list-tile-title>
                        <v-list-tile-sub-title
                          >{{ item.FlightSegments[1].DepartureAirportName }} ({{
                            item.FlightSegments[1].DepartureAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>

                  <v-flex xs12 sm4 md5>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title>{{
                          item.FlightSegments[1].ArrivalTime
                        }}</v-list-tile-title>
                        <v-list-tile-sub-title>
                          {{ item.FlightSegments[1].ArrivalAirportName }} ({{
                            item.FlightSegments[1].ArrivalAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>
                </v-layout>
              </v-card>

              <!-- AKTARMALI GIDIS DONUS -->
              <v-card
                class="my-2 elevation-4"
                v-if="item.FlightSegments.length == 4"
              >
                <v-layout row wrap>
                  <v-flex xs12 sm4 md2 class="my-auto">
                    <v-img
                      :src="getImgUrl(item.FlightSegments[0].OperatingAirline)"
                      alt="K"
                      height="35px"
                      width="85px"
                      contain
                    >
                    </v-img>
                  </v-flex>
                  <v-flex xs12 sm4 md5>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title
                          >{{
                            item.FlightSegments[0].DepartureDate.substring(
                              0,
                              10
                            )
                          }}
                          {{
                            item.FlightSegments[0].DepartureTime
                          }}</v-list-tile-title
                        >
                        <v-list-tile-sub-title
                          >{{ item.FlightSegments[0].DepartureAirportName }} ({{
                            item.FlightSegments[0].DepartureAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>

                  <v-flex xs12 sm4 md5>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title
                          >{{
                            item.FlightSegments[0].ArrivalDate.substring(0, 10)
                          }}
                          {{
                            item.FlightSegments[1].ArrivalTime
                          }}</v-list-tile-title
                        >
                        <v-list-tile-sub-title>
                          {{ item.FlightSegments[1].ArrivalAirportName }} ({{
                            item.FlightSegments[1].ArrivalAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-layout row wrap>
                  <v-flex xs12 sm4 md2 class="my-auto">
                    <v-img
                      :src="
                        getImgUrl(
                          item.FlightSegments[item.FlightSegments.length - 1]
                            .OperatingAirline
                        )
                      "
                      alt="K"
                      height="35px"
                      width="85px"
                      contain
                    >
                    </v-img>
                  </v-flex>
                  <v-flex xs12 sm4 md5>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title>{{
                          item.FlightSegments[2].DepartureTime
                        }}</v-list-tile-title>
                        <v-list-tile-sub-title
                          >{{ item.FlightSegments[2].DepartureAirportName }} ({{
                            item.FlightSegments[2].DepartureAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>
                  <v-flex xs12 sm4 md5>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title>{{
                          item.FlightSegments[3].ArrivalTime
                        }}</v-list-tile-title>
                        <v-list-tile-sub-title>
                          {{ item.FlightSegments[3].ArrivalAirportName }} ({{
                            item.FlightSegments[3].ArrivalAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>
                </v-layout>
              </v-card>

              <!-- AKTARMASIZ TEK YON -->
              <v-card
                class="my-2 elevation-4"
                v-if="item.FlightSegments.length == 1"
              >
                <v-layout row wrap>
                  <v-flex xs12 sm4 md2 class="my-auto">
                    <v-img
                      :src="getImgUrl(item.FlightSegments[0].OperatingAirline)"
                      alt="K"
                      height="35px"
                      width="85px"
                      contain
                    >
                    </v-img>
                  </v-flex>
                  <v-flex xs12 sm4 md5>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{
                            item.FlightSegments[0].DepartureDate.substring(
                              0,
                              10
                            )
                          }}
                          {{
                            item.FlightSegments[0].DepartureTime
                          }}</v-list-tile-title
                        >
                        <v-list-tile-sub-title
                          >{{ item.FlightSegments[0].DepartureAirportName }} ({{
                            item.FlightSegments[0].DepartureAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>

                  <v-flex xs12 sm4 md5>
                    <v-list>
                      <v-list-tile-content>
                        <v-list-tile-title
                          >{{
                            item.FlightSegments[0].ArrivalDate.substring(0, 10)
                          }}
                          {{
                            item.FlightSegments[0].ArrivalTime
                          }}</v-list-tile-title
                        >
                        <v-list-tile-sub-title>
                          {{ item.FlightSegments[0].ArrivalAirportName }} ({{
                            item.FlightSegments[0].ArrivalAirportCode
                          }})</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list>
                  </v-flex>
                </v-layout>
              </v-card>

              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-card
                    v-for="(paxDetails, d) in item.PassengerBreakdowns"
                    v-bind:key="d"
                    class="pb-2"
                    flat
                  >
                    <v-hover>
                      <v-card
                        width="100%"
                        slot-scope="{ hover }"
                        :class="`elevation-${hover ? 12 : 2}`"
                        class="elevation-1 pt-3 pl-3 pb-3"
                      >
                        <v-layout row wrap align-center justify-end>
                          <v-flex xs12 sm6 md4>
                            <v-flex
                              xs12
                              sm12
                              md12
                              class="font-weight-medium grey--text body-2"
                              style="color: #67768f"
                            >
                              <span style="color: #67768f">
                                {{ d + 1 }} .
                                {{
                                  paxDetails.PaxReference.PaxCode
                                    | passengerType
                                }}
                                {{ $t("Passenger") }} :</span
                              >
                            </v-flex>
                            <v-flex
                              xs12
                              sm12
                              md12
                              class="font-weight-medium grey--text caption"
                              style="color: #67768f"
                            >
                              <span style="color: #67768f"
                                >{{ $t("Net") }} :</span
                              >
                              {{ paxDetails.BaseFare }}
                            </v-flex>
                            <v-flex
                              xs12
                              sm12
                              md12
                              class="font-weight-medium grey--text caption"
                              style="color: #67768f"
                            >
                              <span style="color: #67768f"
                                >{{ $t("Tax-v2") }} :</span
                              >
                              {{ paxDetails.TotalTax }}
                            </v-flex>
                          </v-flex>

                          <v-flex xs12 sm6 md4>
                            <v-flex
                              xs12
                              sm12
                              md12
                              class="font-weight-medium grey--text caption"
                              style="color: #67768f"
                            >
                              <span style="color: #67768f">
                                {{ $t("Service") }} :</span
                              >
                              {{ paxDetails.TotalServiceFee }}
                            </v-flex>
                            <v-flex
                              xs12
                              sm12
                              md12
                              class="font-weight-medium grey--text caption"
                              style="color: #67768f"
                            >
                              <span style="color: #67768f"
                                >{{ $t("Maturity") }}:</span
                              >
                              {{ paxDetails.TotalLateInterest }}
                            </v-flex>
                            <v-flex
                              xs12
                              sm12
                              md12
                              class="font-weight-medium grey--text caption"
                              style="color: #67768f"
                            >
                              <span style="color: #67768f">
                                {{ $t("Markup") }} :</span
                              >
                              {{ paxDetails.TotalMarkupFare }}
                            </v-flex>
                          </v-flex>

                          <v-flex xs12 sm6 md4>
                            <v-flex
                              xs12
                              sm12
                              md12
                              class="font-weight-medium grey--text caption"
                              style="color: #67768f"
                            >
                              <span style="color: #67768f">L.Markup:</span>
                              {{ paxDetails.TotalMarkupFareList }}
                            </v-flex>
                            <v-flex
                              xs12
                              sm12
                              md12
                              class="font-weight-medium grey--text caption"
                              style="color: #67768f"
                            >
                              <span style="color: #67768f"
                                >{{ $t("Total") }}:</span
                              >
                              {{ paxDetails.TotalFare }}
                            </v-flex>
                            <v-flex
                              xs12
                              sm12
                              md12
                              class="font-weight-medium grey--text caption"
                              style="color: #67768f"
                            >
                              <span style="color: #67768f"
                                >{{ $t("Currency-Unit") }} :</span
                              >
                              {{ paxDetails.Currency }}
                            </v-flex>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-hover>
                  </v-card>

                  <v-card class="my-2 elevation-2 pa-2">
                    <v-layout row wrap align-center justify-end>
                      <v-flex xs12 sm6 md4>
                        <v-flex
                          xs12
                          sm12
                          md12
                          class="font-weight-medium grey--text body-2"
                          style="color: #67768f"
                        >
                          <span style="color: #67768f"
                            >{{ $t("Totals") }} :</span
                          >
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          md12
                          class="font-weight-medium grey--text caption"
                          style="color: #67768f"
                        >
                          <span style="color: #67768f">Toplam Net:</span>
                          {{ footerBaseFare }}
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          md12
                          class="font-weight-medium grey--text caption"
                          style="color: #67768f"
                        >
                          <span style="color: #67768f">Toplam Vergi:</span>
                          {{ footerTotalTax }}
                        </v-flex>
                      </v-flex>

                      <v-flex xs12 sm6 md4>
                        <v-flex
                          xs12
                          sm12
                          md12
                          class="font-weight-medium grey--text caption"
                          style="color: #67768f"
                        >
                          <span style="color: #67768f">Toplam Servis :</span>
                          {{ footerTotalServiceFee }}
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          md12
                          class="font-weight-medium grey--text caption"
                          style="color: #67768f"
                        >
                          <span style="color: #67768f">Toplam Vade:</span>
                          {{ footerLateInterest }}
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          md12
                          class="font-weight-medium grey--text caption"
                          style="color: #67768f"
                        >
                          <span style="color: #67768f">Toplam Markup:</span>
                          {{ footerTotalMarkupFare }}
                        </v-flex>
                      </v-flex>

                      <v-flex xs12 sm6 md4>
                        <v-flex
                          xs12
                          sm12
                          md12
                          class="font-weight-medium grey--text caption"
                          style="color: #67768f"
                        >
                          <span style="color: #67768f">Toplam L.Markup :</span>
                          {{ footerTotalMarkupFareList }}
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          md12
                          class="font-weight-medium grey--text caption"
                          style="color: #67768f"
                        >
                          <span style="color: #67768f">Toplam Tutar:</span>
                          {{ footerTotalFare }}
                        </v-flex>
                      </v-flex>
                    </v-layout>
                  </v-card>

                  <!-- <v-data-table
                  :headers="headersSummary"
                  :items="item.PassengerBreakdowns"
                  hide-actions
                  class="elevation-1"
                  item-key="id"
                  style="max-width: 500px"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-left">
                      {{ props.item.PaxReference.PaxCode }}
                    </td>
                    <td class="text-xs-left">{{ props.item.BaseFare }}</td>
                    <td class="text-xs-left">
                      {{ props.item.TotalTax }}
                    </td>
                    <td class="text-xs-left">
                      {{ props.item.TotalServiceFee }}
                    </td>
                    <td class="text-xs-left">
                      {{ props.item.TotalLateInterest }}
                    </td>
                    <td class="text-xs-left">
                      {{ props.item.TotalMarkupFare }}
                    </td>
                    <td class="text-xs-left">
                      {{ props.item.TotalMarkupFareList }}
                    </td>
                    <td class="text-xs-left">
                      {{ props.item.TotalFare }}
                    </td>
                    <td class="text-xs-left">{{ props.item.Currency }}</td>
                  </template>

                  <template v-slot:footer>
                    <td>
                      <strong> {{ $t('Totals') }} </strong>
                    </td>
                    <td>
                      <strong>{{ footerBaseFare }}</strong>
                    </td>
                    <td>
                      <strong> {{ footerTotalTax }} </strong>
                    </td>
                    <td>
                      <strong> {{ footerTotalServiceFee }} </strong>
                    </td>
                    <td>
                      <strong> {{ footerLateInterest }} </strong>
                    </td>
                    <td>
                      <strong> {{ footerTotalMarkupFare }} </strong>
                    </td>
                    <td>
                      <strong> {{ footerTotalMarkupFareList }} </strong>
                    </td>
                    <td>
                      <strong> {{ footerTotalFare }} </strong>
                    </td>
                    <td>
                      <strong>&nbsp; </strong>
                    </td>
                  </template>
                </v-data-table> -->
                </v-flex>
              </v-layout>

              <v-layout row wrap pt-2>
                <v-flex
                  xs12
                  sm12
                  md12
                  v-if="
                    item.FlightSegments[0].FareCode != null &&
                    item.FlightSegments[0].FareCode == 'Promo'
                  "
                >
                  <v-chip outline color="primary" text-color="primary">
                    <v-icon color="primary" left>flight</v-icon>
                    {{ item.Provider }} {{ $t("Promotion") }}
                  </v-chip>
                  <v-chip label color="primary" text-color="primary">
                    <v-icon color="primary" left>info</v-icon>
                    {{
                      $t("Cancellation-returns-not-available-promotion-tickets")
                    }}
                  </v-chip>
                </v-flex>

                <v-flex xs12 sm12 md12 v-else>
                  <v-chip outline color="primary" text-color="primary">
                    <v-icon color="primary" left>flight</v-icon>
                    {{ item.Provider }} {{ $t("Flexible") }}
                  </v-chip>
                  <v-chip outline color="primary" text-color="primary">
                    <v-icon color="primary" left>info</v-icon>
                    {{
                      $t(
                        "Cancellation-changes-returns-flexible-tickets-subject-certain-rules"
                      )
                    }}
                  </v-chip>
                </v-flex>
              </v-layout>

              <v-flex
                xs12
                sm12
                md12
                v-if="!isUpdate"
                v-for="(itemSegment, indexSeg) in item.FlightSegments"
                :key="indexSeg"
              >
                <!-- <v-flex v-if="!itemSegment.PricingInfo!=null"
                  v-for="(itemPricingInfo, indexPrice) in itemSegment.PricingInfo.FareBreakdowns"
                  :key="indexPrice"
                >
                  <v-flex
                    v-for="(itemAmenities, indexAmen) in itemPricingInfo.Amenities"
                    :key="indexAmen"
                    xs12
                    sm12
                    md12
                  >
                    <v-chip outline color="green">
                      <v-icon color="green" left>luggage</v-icon>
                      {{ itemAmenities.Description }}</v-chip
                    >
                  </v-flex>
                </v-flex> -->
              </v-flex> 

              <v-flex
                xs12
                sm12
                md12
                v-for="(itemPassengers, k) in item.PassengerBreakdowns"
                :key="k"
              >
                <template
                  v-for="(itemPassengersMessages, l) in itemPassengers.Messages"
                >
                  <v-flex xs12 sm12 md12 :key="l" v-if="itemPassengersMessages != null">
                    <v-chip outline color="red">
                      <v-icon color="red" left>warning</v-icon>
                      {{ itemPassengersMessages }}</v-chip
                    >
                  </v-flex>
                </template>
              </v-flex>
              <v-layout row wrap v-if="!isUpdate">
                <v-flex xs12 sm6 md6 pr-2>
                  <v-btn color="primary" @click="updatePassenger(1)" block>
                    <v-icon left>book_online</v-icon>
                    {{ $t("Make-a-Reservation") }}
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm6 md6 pl-2>
                  <v-btn color="success" @click="updatePassenger(2)" block>
                    <v-icon left>add_shopping_cart</v-icon>
                    {{ $t("Continue-to-Payment") }}
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="isUpdate">
                <v-flex xs12 sm6 md6 pr-2>
                  <v-btn
                    color="red lighten-1"
                    :disabled="!IsCancelable"
                    @click="cancelReservation()"
                    block
                  >
                    <v-icon left>cancel</v-icon>
                    {{ $t("Cancel-Reservation-v2") }}
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm6 md6 pl-2>
                  <v-btn color="success" @click="makePayment()" block>
                    <v-icon left>add_shopping_cart</v-icon>
                    {{ $t("Continue-to-Payment") }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-form>

    <v-layout row justify-center>
      <v-dialog v-model="dialog" persi persistent max-width="390">
        <v-card>
          <v-card-text
            >Biletiniz oluşturulmuştur. Minumum 5 dakika içinde Next Arkman
            sistemine aktarılacaktır.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import auth from "@/api/auth.js";
import logoo from "@/assets/control.js";
import Airports from "@/components/app/satis/ucak/airports.js";
import caricomp from "@/components/app/customcomp/caricomp.vue";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import helpers from "@/components/app/customcomp/helpers.js";
import doviz from "@/components/app/muhasebe/comp/doviz.vue";

export default {
  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t("Mandatory-Areas"),
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t("Wrong-e-mail");
        },
      },
      dialog: false,
      valid: true,
      cariItem: null,
      billingInformationItem: Airports.billingInformation(),
      makePrebookingItem: Airports.makePrebooking(),
      finalizeShoppingItem: Airports.finalizeShopping(),
      updatePassengerItem: Airports.updatePassengers(),
      WheelChairItems: Airports.wheelChairs(),
      countryItems: Airports.countiries(),
      genderItems: Airports.Genders(),
      headersSummary: Airports.headersFlightInfoSummary(),
      makePaymentItem: Airports.makePayment(),
      nextTicket: Airports.nextTicket(),
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      ticketAllocate: [],
      passengerList: [],
      paxList: [],
      footerBaseFare: 0,
      footerTotalTax: 0,
      footerTotalServiceFee: 0,
      footerLateInterest: 0,
      footerTotalMarkupFare: 0,
      footerTotalMarkupFareList: 0,
      footerTotalFare: 0,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      flightType: null,
      CurrentCode: null,
      isContactDefault: -1,
      defaultContactValue: false,
      contactValueList: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      currencyValue: 0,
      isUpdate: false,
      IsCancelable: false,
      syncFirstName: null,
    };
  },
  methods: {
    checkPhoneFormat(value){
      let zeroControl = value.substring(0,1);
      
      if(zeroControl == 0){
        return "+90-" + value.substring(1);
      }else{
        return "+90-" + value;
      }

    },
    changePhone(phone) {
      this.updatePassengerItem.Contact.Phone = phone;
    },
    changeEmail(email) {
      if (this.paxList.length == 1) {
        this.updatePassengerItem.Contact.Email = email;
      }
    },
    changeLastName(lastName) {
      if (this.paxList.length == 1) {
        this.updatePassengerItem.Contact.LastName = lastName;
      }
    },
    changeFirstName(firstName) {
      if (this.paxList.length == 1) {
        this.updatePassengerItem.Contact.Name = firstName;
      }
    },
    cancelReservation() {
      this.loadingvmodel = true;
      var bookingParams = JSON.parse(
        window.localStorage.getItem("bookingParams")
      );
      var params = {
        SessionHeader: {
          SessionId: bookingParams.SessionId,
          SessionToken: bookingParams.SessionToken,
        },
        bookingData: {
          locator: this.$route.query.pnr,
        },
        ShoppingCartId: window.localStorage.getItem("shopCartID"),
      };

      this.$http
        .post('https://testbookingapi.arkman.com.tr/' + "Air/CancelReservation", params)
        .then(
          (response) => {
            if (!response.body.HasError) {
              this.loadingvmodel = false;
              this.text1 = "Rezervasyon iptal edildi";
              this.snackbar = true;

              setTimeout(
                function () {
                  var url1 = "#/satis/ucus/rezervasyonliste";
                  window.open(url1, "_self");
                }.bind(this),
                1250
              );
            } else {
              this.text1 = response.body.ServiceError.ErrorMessages[0];
              this.snackbar = true;
              this.loadingvmodel = false;
              this.snackbarkColor = "warning";
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Air/CancelReservation";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-Air/CancelReservation";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    searchBillingInfo(val) {
      let params = {
        q: val,
        Coper: false,
      };

      this.$http
        .post(auth.API_URL + "api/options/CurrentSearch", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.cariItem = response.body[0].id;
            if (this.$route.query.islem == "new") {
              this.billingSubmit();
            } else {
              this.nextTicket.GenelBilgileri.MusteriKodu.Kod =
                response.body[0].id;
            }
          },
          (response) => {
            if (response.status === 0) {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
            } else {
              this.text1 = response.statusText;
              this.snackbar = true;
            }
          }
        );
    },
    moneyformat(m) {
      if (m != 0) {
        return m.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
      } else {
        return 0;
      }
    },
    defaultContact(contact, index) {
      if (
        this.isContactDefault != index &&
        this.contactValueList[index] != false
      ) {
        this.updatePassengerItem.Contact.Name = contact.FirstName;
        this.updatePassengerItem.Contact.LastName = contact.LastName;
        this.updatePassengerItem.Contact.Phone = contact.Phone;
        this.updatePassengerItem.Contact.Email = contact.Email;
        this.isContactDefault = index;
      } else {
        this.updatePassengerItem.Contact.Name = "";
        this.updatePassengerItem.Contact.LastName = "";
        this.updatePassengerItem.Contact.Phone = "";
        this.updatePassengerItem.Contact.Email = "";
        this.isContactDefault = -1;
      }
    },
    sendNextTicket(val) {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      this.nextTicket.GenelBilgileri.SirketKodu = credentials.SirketKodu;

      val.AirBookings.forEach((element) => {
        for (
          let index = 0;
          index < element.PassengerBreakdowns.length;
          index++
        ) {
          const breakdown = element.PassengerBreakdowns[index];

          this.nextTicket.GenelBilgileri.BiletNo =
            breakdown.TicketNumber.substring(4);
          this.nextTicket.GenelBilgileri.Formno =
            breakdown.TicketNumber.substring(0, 3);

          //   var ticketNumber =
          // Math.floor(Math.random() * (9999999999 - 1000000000 + 1)) +
          // 1000000000;
          // this.nextTicket.GenelBilgileri.BiletNo = ticketNumber;
          // this.nextTicket.GenelBilgileri.Formno = 235;
          this.nextTicket.GenelBilgileri.HavaYoluKodu =
            element.FlightSegments[0].MarkettingAirline;

          this.nextTicket.GenelBilgileri.Acente = "A";
          this.nextTicket.GenelBilgileri.AcenteKodu = "SEM";
          this.nextTicket.GenelBilgileri.ArkmanUsers = "WEB";
          this.nextTicket.GenelBilgileri.Crs = "AerTicket";

          this.nextTicket.GenelBilgileri.UcusTipi = "D"; //Sadece dis hatlar mi olacak ?
          if (this.$route.query.islem == "new") {
            this.nextTicket.GenelBilgileri.MusteriKodu.Kod = this.CurrentCode;
          }
          this.nextTicket.GenelBilgileri.MusteriKodu.Unvan =
            val.BillingInformation.BillingName;

          var analysisprice =
            breakdown.TotalMarkupFare + breakdown.TotalMarkupFareList;

          var baseFare = breakdown.BaseFare;
          // var serviceFee =
          //   breakdown.TotalServiceFee +
          //   analysisprice -
          //   passenger.ExtraPosAmount;

          baseFare -= analysisprice;

          // Tutar Bilgileri

          this.nextTicket.TutarBilgileri.NetTutar.NetTutar =
            this.footerTotalFare;
          this.nextTicket.TutarBilgileri.TaxTutar.TaxTutar =
            this.footerTotalTax;
          this.nextTicket.TutarBilgileri.ServisTutar.ServisTutar =
            this.footerTotalMarkupFare;
          this.nextTicket.TutarBilgileri.Tutar.Tutar = this.footerBaseFare;
          this.nextTicket.NotlarBilgileri.RefFare = this.footerBaseFare;
          this.nextTicket.NotlarBilgileri.LowFare =
            this.footerBaseFare - this.footerTotalMarkupFare;
          // this.nextTicket.TutarBilgileri.DigerServisTutar.DigerServisTutar = passenger.ExtraPosAmount;
          this.nextTicket.TutarBilgileri.Kur = val.Currency;

          this.nextTicket.TanimBilgileri.AnalizKod.AnalizTutar = analysisprice;
          this.nextTicket.TanimBilgileri.AnalizKod.AnalizKod = "KOM";

          this.nextTicket.TarihBilgileri.SatisTarihi = helpers.getDateNow();
          this.nextTicket.TarihBilgileri.OdemeTarihi = helpers.getDateNow();

          var destination1 = element.FlightSegments[0].DepartureAirportCode;
          var destination2 = element.FlightSegments[0].ArrivalAirportCode;
          var destination3;
          var destination4;
          var destination5;

          switch (element.FlightSegments.Count) {
            case 2:
              destination3 = element.FlightSegments[1].ArrivalAirportCode;
              destination4 = "";
              destination5 = "";
              break;
            case 3:
              destination3 = element.FlightSegments[1].ArrivalAirportCode;
              destination4 = element.FlightSegments[2].ArrivalAirportCode;
              destination5 = "";
              break;
            case 4:
              destination3 = element.FlightSegments[1].ArrivalAirportCode;
              destination4 = element.FlightSegments[1].DepartureAirportCode;
              destination5 = element.FlightSegments[3].ArrivalAirportCode;
              break;
            case 5:
              destination3 = element.FlightSegments[
                element.FlightSegments.length - 1
              ].find((x) => x.DirectionInd == 0).ArrivalAirportCode;
              destination4 = element.FlightSegments[
                element.FlightSegments.length - 1
              ].find((x) => x.DirectionInd == 1).DepartureAirportCode;
              destination5 = element.FlightSegments[
                element.FlightSegments.length - 1
              ].find((x) => x.DirectionInd == 1).ArrivalAirportCode;
              break;
            case 6:
              destination3 = element.FlightSegments[
                element.FlightSegments.length - 1
              ].find((x) => x.DirectionInd == 0).ArrivalAirportCode;
              destination4 = element.FlightSegments[
                element.FlightSegments.length - 1
              ].find((x) => x.DirectionInd == 1).DepartureAirportCode;
              destination5 = element.FlightSegments[
                element.FlightSegments.length - 1
              ].find((x) => x.DirectionInd == 1).ArrivalAirportCode;
              break;
            case 7:
              destination3 = element.FlightSegments[1].DepartureAirportCode;
              destination4 = element.FlightSegments[2].ArrivalAirportCode;
              destination5 = element.FlightSegments[3].ArrivalAirportCode;
              break;
            default:
              destination3 = "";
              destination4 = "";
              destination5 = "";
              break;
          }
          this.nextTicket.GenelBilgileri.Parkurlar.Parkur1 = destination1;
          this.nextTicket.GenelBilgileri.Parkurlar.Parkur2 = destination2;
          this.nextTicket.GenelBilgileri.Parkurlar.Parkur3 = destination3;
          this.nextTicket.GenelBilgileri.Parkurlar.Parkur4 = destination4;
          this.nextTicket.GenelBilgileri.Parkurlar.Parkur5 = destination5;

          this.nextTicket.GenelBilgileri.PnrNo = element.BookingCode;

          // yon bilgisi
          var ow = false;
          var rt = false;

          var fsCount = element.FlightSegments.length;

          if (fsCount == 1) {
            ow = true;
          } else {
            rt =
              element.FlightSegments[0].DepartureAirportCode ==
              element.FlightSegments[element.FlightSegments.length - 1]
                .ArrivalAirportCode;
          }

          if (ow) {
            this.nextTicket.GenelBilgileri.BiletYon = "T";
          } else if (rt) {
            this.nextTicket.GenelBilgileri.BiletYon = "C";
          } else {
            this.nextTicket.GenelBilgileri.BiletYon = "T";
          }

          var passenger = val.Passengers.find(
            (x) => x.PaxReferanceId == breakdown.PaxReference.PaxReferanceId
          );
          this.nextTicket.GenelBilgileri.YolcuAdi =
            passenger.FirstName + " " + passenger.LastName;
          this.nextTicket.GenelBilgileri.FiyatTur = passenger.PaxType;
          this.nextTicket.GenelBilgileri.HesKodu = passenger.HesCode;
          this.nextTicket.GenelBilgileri.Email =
            this.updatePassengerItem.Contact.Email;
          this.nextTicket.GenelBilgileri.BiletTel =
            this.updatePassengerItem.Contact.Phone.substring(4);

          this.$http
            .post(auth.API_URL + "api/Ticket/TicketAdd", this.nextTicket, {
              headers: {
                Authorization: "Bearer " + auth.getAuthHeader(),
              },
            })
            .then(
              (response) => {
                 this.text1 = this.$t(response.body.ResponseMessage);
                this.snackbar = true;
                this.loadingdialog = false;
                if (response.body.Status != Boolean(false)) {
                  this.loadingvmodel = false;
                  this.snackbar = true;
                  this.snackbarkColor = "success";
                  this.text1 = "Rezervasyon İşlemi Tamamlandı.";

                  setTimeout(
                    function () {
                      var url =
                        "#/bilet/yeni/id?" +
                        "isl=get&hyolukod=" +
                        this.nextTicket.GenelBilgileri.HavaYoluKodu +
                        "&biletno=" +
                        this.nextTicket.GenelBilgileri.BiletNo +
                        "&ucustipi=" +
                        this.nextTicket.GenelBilgileri.UcusTipi +
                        "&tab=0";
                      location.href = url;
                      location.reload();
                    }.bind(this),
                    3000
                  );
                } else {
                   this.text1 = this.$t(response.body.ResponseMessage);
                  this.snackbar = true;
                  this.loadingvmodel = false;
                }
              },
              (response) => {
                 this.text1 = this.$t(response.body.ResponseMessage);
                this.snackbar = true;

                if (response.status === 0) {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                } else {
                   this.text1 = this.$t(response.body.ResponseMessage);
                  this.snackbar = true;
                }
              }
            );
        }
      });
    },
    getBillingInfo() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      var params = {
        Code: this.cariItem,
        CompanyCode: credentials.SirketKodu,
      };

      this.$http
        .post(auth.API_URL + "api/Current/Get", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.CurrentCode = response.body.Code;
            this.billingInformationItem.BillingInformation.BillingName =
              response.body.Title;
            this.billingInformationItem.BillingInformation.Address =
              response.body.Invoice.Address;
            this.billingInformationItem.BillingInformation.City =
              response.body.Invoice.Province;
            this.billingInformationItem.BillingInformation.TaxOffice =
              response.body.Invoice.TaxOffice;
            this.billingInformationItem.BillingInformation.TaxNo =
              response.body.Invoice.TaxNumber;

            //this.billingSubmit();
          },
          (response) => {
            if (response.status === 0) {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
            } else {
              this.text1 = response.statusText;
              this.snackbar = true;
            }
          }
        );
    },
    billingSubmit(val) {
      var bookingParams = JSON.parse(
        window.localStorage.getItem("bookingParams")
      );
      if (this.billingInformationItem.BillingInformation.TaxNo != "") {
        this.billingInformationItem.SessionHeader.SessionId =
          bookingParams.SessionId;
        this.billingInformationItem.SessionHeader.SessionToken =
          bookingParams.SessionToken;
        this.billingInformationItem.ShoppingCartId =
          window.localStorage.getItem("shopCartID");

        this.$http
          .post(
            'https://testbookingapi.arkman.com.tr/' + "Billing/Submit",
            this.billingInformationItem
          )
          .then(
            (response) => {
              if (!response.body.HasError) {
                this.makePrebooking(val);
              } else {
                this.text1 = response.body.ServiceError.ErrorMessages[0];
                this.snackbar = true;
                this.loadingvmodel = false;
                this.snackbarkColor = "warning";
                this.unLockShoppingCart();
              }
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-Air/MakePrebooking";
                this.snackbar = true;
                this.loadingvmodel = false;
              } else {
                this.text1 = "Service Unavailable-Air/MakePrebooking";
                this.snackbar = true;
                this.loadingvmodel = false;
              }
            }
          );
      } else {
        setTimeout(() => {
          this.billingSubmit(val);
        }, 1500);
      }
    },
    makePayment() {
      this.loadingvmodel = true;
      var bookingParams = JSON.parse(
        window.localStorage.getItem("bookingParams")
      );
      var Amount = (this.footerTotalFare * 1) / this.currencyValue;
      this.makePaymentItem.SessionHeader.SessionId = bookingParams.SessionId;
      this.makePaymentItem.SessionHeader.SessionToken =
        bookingParams.SessionToken;
      this.makePaymentItem.ShoppingCartId =
        window.localStorage.getItem("shopCartID");
      this.makePaymentItem.Amount = this.moneyformat(Amount);

      this.$http
        .post('https://testbookingapi.arkman.com.tr/' + "MakePayment", this.makePaymentItem)
        .then(
          (response) => {
            if (!response.body.HasError) {
              this.finalizeShopping();
            } else {
              this.text1 = response.body.ServiceError.ErrorMessages[0];
              this.snackbar = true;
              this.loadingvmodel = false;
              this.snackbarkColor = "warning";
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Payment/MakePayment";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-Payment/MakePayment";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    finalizeShopping() {
      var bookingParams = JSON.parse(
        window.localStorage.getItem("bookingParams")
      );

      this.finalizeShoppingItem.SessionHeader.SessionId =
        bookingParams.SessionId;
      this.finalizeShoppingItem.SessionHeader.SessionToken =
        bookingParams.SessionToken;
      this.finalizeShoppingItem.ShoppingCartId =
        window.localStorage.getItem("shopCartID");

      this.$http
        .post(
          'https://testbookingapi.arkman.com.tr/' + "Air/FinalizeShopping",
          this.finalizeShoppingItem
        )
        .then(
          (response) => {
            if (!response.body.HasError) {
              this.dialog = true;
              setTimeout(
                function () {
                  var url = "#/satis/ucus/liste";
                  location.href = url;
                  location.reload();
                }.bind(this),
                3000
              );
              //Bilet kayiti booking apiye alindi.
              //this.sendNextTicket(response.body.ShoppingCart);
            } else {
              this.text1 = response.body.ServiceError.ErrorMessages[0];
              this.snackbar = true;
              this.loadingvmodel = false;
              this.snackbarkColor = "warning";
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Air/MakePrebooking";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-Air/MakePrebooking";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    makePrebooking(val) {
      //val 1 : prebooking val 2 : booking
      var bookingParams = JSON.parse(
        window.localStorage.getItem("bookingParams")
      );
      if (val == 1) {
        this.makePrebookingItem.ContinueWithoutReservation = false;
      } else {
        this.makePrebookingItem.ContinueWithoutReservation = true;
      }
      this.makePrebookingItem.SessionHeader.SessionId = bookingParams.SessionId;
      this.makePrebookingItem.SessionHeader.SessionToken =
        bookingParams.SessionToken;
      this.makePrebookingItem.ShoppingCartId =
        window.localStorage.getItem("shopCartID");
      this.$http
        .post(
          'https://testbookingapi.arkman.com.tr/' + "Air/MakePrebooking",
          this.makePrebookingItem
        )
        .then(
          (response) => {
            if (!response.body.HasError) {
              if (val == 1) {
                this.loadingvmodel = false;
                this.snackbar = true;
                this.snackbarkColor = "success";
                this.text1 = "Ön Rezervasyon İşlemi Tamamlandı.";
                setTimeout(
                  function () {
                    var url1 =
                      "#/satis/ucus/islem/id?" +
                      "isl=get&pnr=" +
                      response.body.ShoppingCart.AirBookings[0].BookingCode;
                    location.href = url1;
                    location.reload();
                  }.bind(this),
                  3000
                );
              } else {
                this.makePayment();
              }
            } else {
              this.text1 = response.body.ServiceError.ErrorMessages[0];
              this.snackbar = true;
              this.loadingvmodel = false;
              this.snackbarkColor = "warning";
              this.unLockShoppingCart();
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Air/MakePrebooking";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-Air/MakePrebooking";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    updatePassenger(val) {
      //val 1 : prebooking val 2 : booking
      if (this.$refs.formTicket.validate()) {
        this.loadingvmodel = true;
        if (this.cariItem != null) {
          this.getBillingInfo();
        }

        var bookingParams = JSON.parse(
          window.localStorage.getItem("bookingParams")
        );

        let params = {};

        params = JSON.parse(JSON.stringify(this.updatePassengerItem));

        params.SessionHeader.SessionId = bookingParams.SessionId;
        params.SessionHeader.SessionToken = bookingParams.SessionToken;
        params.Passengers = this.paxList;
        params.ShoppingCartId = window.localStorage.getItem("shopCartID");

        params.Contact.Phone = this.checkPhoneFormat(params.Contact.Phone);

        params.Passengers.forEach((element) => {
          element.Phone =  this.checkPhoneFormat(element.Phone);
          element.BirthDate = element.BirthDate.split("T")[0];

          if (element.PassportExpireDate == "0001-01-01T00:00:00") {
            element.PassportExpireDate = "";
          }
        });

        this.$http
          .post('https://testbookingapi.arkman.com.tr/' + "Air/UpdatePassengers", params)
          .then(
            (response) => {
              if (!response.body.HasError) {
                this.billingSubmit(val);
              } else {
                this.text1 = response.body.ServiceError.ErrorMessages[0];
                this.snackbar = true;
                this.loadingvmodel = false;
                this.snackbarkColor = "warning";
                this.unLockShoppingCart();
              }
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-Air/UpdatePassengers";
                this.snackbar = true;
                this.loadingvmodel = false;
              } else {
                this.text1 = "Service Unavailable-Air/UpdatePassengers";
                this.snackbar = true;
                this.loadingvmodel = false;
              }
            }
          );
      } else {
        this.text1 = this.$t('Please-fill-in-the-required-fields.');
        this.snackbar = true;
        this.loadingvmodel = false;
        this.snackbarkColor = "warning";
      }
    },
    unLockShoppingCart(){
        this.loadingvmodel = true;

        var bookingParams = JSON.parse(
          window.localStorage.getItem("bookingParams")
        );

        let params = {};

        params.SessionHeader.SessionId = bookingParams.SessionId;
        params.SessionHeader.SessionToken = bookingParams.SessionToken;
        params.ShoppingCartId = window.localStorage.getItem("shopCartID");

        this.$http
          .post('https://testbookingapi.arkman.com.tr/' + "Air/UpdatePassengers", params)
          .then(
            (response) => {
              if (response.body.HasError) {
                this.text1 = response.body.ServiceError.ErrorMessages[0];
                this.snackbar = true;
                this.loadingvmodel = false;
                this.snackbarkColor = "warning";
              } 
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-Air/UpdatePassengers";
                this.snackbar = true;
                this.loadingvmodel = false;
              } else {
                this.text1 = "Service Unavailable-Air/UpdatePassengers";
                this.snackbar = true;
                this.loadingvmodel = false;
              }
            }
          );
    },
    calculateFooter() {
      //todo
      this.ticketAllocate[0].PassengerBreakdowns.forEach((element) => {
        this.footerBaseFare =
          parseFloat(this.footerBaseFare) +
          parseFloat(element.BaseFare.toString().replace(/,/g, ""));
        this.footerTotalTax =
          parseFloat(this.footerTotalTax) +
          parseFloat(element.TotalTax.toString().replace(/,/g, ""));
        this.footerTotalServiceFee =
          parseFloat(this.footerTotalServiceFee) +
          parseFloat(element.TotalServiceFee.toString().replace(/,/g, ""));

        this.footerLateInterest =
          parseFloat(this.footerLateInterest) +
          parseFloat(element.TotalLateInterest.toString().replace(/,/g, ""));

        this.footerTotalMarkupFare =
          parseFloat(this.footerTotalMarkupFare) +
          parseFloat(element.TotalMarkupFare.toString().replace(/,/g, ""));

        this.footerTotalMarkupFareList =
          parseFloat(this.footerTotalMarkupFareList) +
          parseFloat(element.TotalMarkupFareList.toString().replace(/,/g, ""));

        this.footerTotalFare =
          this.footerTotalFare +
          parseFloat(element.TotalFare.toString().replace(/,/g, ""));
      });
    },
    calculateHourAndMinute(value) {
      var hours = value / 60;
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      if (rhours == 0) {
        return rminutes + " dakika";
      } else if (rminutes == 0) {
        return rhours + " saat ";
      } else {
        return rhours + " sa " + rminutes + " dk";
      }
    },
    getImgUrl(img) {
      return logoo.logoControl(img);
    },
    setCurrency(val) {
      this.currencyValue = val;
    },
    allocated() {
      this.loadingvmodel = true;
      var allocateParams = JSON.parse(
        window.localStorage.getItem("allocateParams")
      );

      this.$http
        .post('https://testbookingapi.arkman.com.tr/' + "Air/Allocate", allocateParams)
        .then(
          (response) => {
            if (!response.body.HasError) {
              this.ticketAllocate = response.body.ShoppingCart.AirBookings;

              this.ticketAllocate.forEach((data) => {
                for (
                  let index = 0;
                  index < data.PassengerBreakdowns.length;
                  index++
                ) {
                  const element = data.PassengerBreakdowns[index];

                  element.BaseFare = this.moneyformat(element.BaseFare);
                  element.TotalFare = this.moneyformat(element.TotalFare );
                  element.TotalLateInterest = this.moneyformat(element.TotalLateInterest );
                  element.TotalMarkupFare = this.moneyformat(element.TotalMarkupFare);
                  element.TotalMarkupFareList = this.moneyformat(element.TotalMarkupFareList);
                  element.TotalServiceFee = this.moneyformat(element.TotalServiceFee);
                  element.TotalTax = this.moneyformat(element.TotalTax);
                }
              });

              window.localStorage.setItem(
                "shopCartID",
                response.body.ShoppingCart.Id
              );

              this.passengerList =
                response.body.ShoppingCart.AirBookings[0].PassengerBreakdowns;
              this.passengerList.forEach((element) => {
                var passenger = Airports.passenger();

                passenger.PaxType = element.PaxReference.PaxCode;
                passenger.PaxReferanceId = element.PaxReference.PaxReferanceId;
                this.paxList.push(passenger);
              });

              this.loadingvmodel = false;
              this.calculateFooter();
            } else {
              this.text1 = response.body.ServiceError.ErrorMessages[0];
              this.snackbar = true;
              this.loadingvmodel = false;
              this.snackbarkColor = "warning";
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Air/Allocate";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-Air/Allocate";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
  },
  watch: {
    "paxs.FirstName": function (val) {
      console.log("TEST  = " + val);
    },
  },
  filters: {
    passengerType: function (val) {
      return Airports.passengerType(val);
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    caricomp,
    tarihim,
    doviz,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    //this.$refs.doviz.getCurrencyValue("EUR");

    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
      //YETKİ OK
          if (this.$route.query.islem == "new") {
          this.isUpdate = false;

          this.flightType = window.localStorage.getItem("flightType");
          this.allocated();

          setTimeout(() => {
            this.countryItems.sort(function (a, b) {
              if (a.name != null && b.name != null) {
                var nameA = a.name.toLowerCase(),
                  nameB = b.name.toLowerCase();
                if (nameA < nameB)
                  //sort string ascending
                  return -1;
                if (nameA > nameB) return 1;
                return 0; //default return value (no sorting)
              }
            });
          }, 1500);
        } else {
          this.loadingvmodel = true;
          this.isUpdate = true;
          var bookingParams = JSON.parse(
            window.localStorage.getItem("bookingParams")
          );

          let params = {
            SessionHeader: {
              SessionId: bookingParams.SessionId,
              SessionToken: bookingParams.SessionToken,
            },
            ShoppingCartId: window.localStorage.getItem("shopCartID"),
          };

          this.$http.post('https://testbookingapi.arkman.com.tr/' + "GetShoppingCart", params).then(
            (response) => {
              if (!response.body.HasError) {
                this.ticketAllocate = response.body.ShoppingCart.AirBookings;
                this.IsCancelable = response.body.ShoppingCart.IsCancelable;
                this.ticketAllocate.forEach((data) => {
                  for (
                    let index = 0;
                    index < data.PassengerBreakdowns.length;
                    index++
                  ) {
                    const element = data.PassengerBreakdowns[index];
                    element.BaseFare = this.moneyformat(element.BaseFare);
                    element.TotalFare = this.moneyformat(element.TotalFare);
                    element.TotalLateInterest = this.moneyformat(element.TotalLateInterest);
                    element.TotalMarkupFare = this.moneyformat(element.TotalMarkupFare);
                    element.TotalMarkupFareList = this.moneyformat(element.TotalMarkupFareList);
                    element.TotalServiceFee = this.moneyformat(element.TotalServiceFee);
                    element.TotalTax = this.moneyformat(element.TotalTax);
                  }
                });

                window.localStorage.setItem(
                  "shopCartID",
                  response.body.ShoppingCart.Id
                );

                this.passengerList = response.body.ShoppingCart.Passengers;

                this.searchBillingInfo(
                  response.body.ShoppingCart.BillingInformation.TaxNo
                );
                this.passengerList.forEach((element) => {
                  var passenger = Airports.passenger();
                  passenger = element;
                  passenger.Phone = element.Phone.substring(4);
                  this.paxList.push(passenger);
                });
                this.updatePassengerItem.Contact =
                  response.body.ShoppingCart.Contact;
                this.updatePassengerItem.Contact.Phone =
                  response.body.ShoppingCart.Contact.Phone.substring(4);
                this.updatePassengerItem.Notes =
                  response.body.ShoppingCart.Notes +
                  "  Rerzervasyon Tarihi = " +
                  response.body.ShoppingCart.CreatedAt;
                this.loadingvmodel = false;
                this.calculateFooter();
              } else {
                this.text1 = response.body.ServiceError.ErrorMessages[0];
                this.snackbar = true;
                this.loadingvmodel = false;
                this.snackbarkColor = "warning";
              }
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-Air/GetShoppingCart";
                this.snackbar = true;
                this.loadingvmodel = false;
              } else {
                this.text1 = "Service Unavailable-Air/GetShoppingCart";
                this.snackbar = true;
                this.loadingvmodel = false;
              }
            }
          );
        }
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
};
</script>

<style>
</style>

